module.exports = __webpack_public_path__ + "img/therapist_photo.cafb7772.png";